module.exports = __webpack_public_path__ + "search-3_decol_o.21ba00c8589dad531cb0392e83b0c174.svg";